webpackJsonp([237503775375457],{

/***/ 1104:
/***/ (function(module, exports) {

	module.exports = {"description":"","displayName":"Video","methods":[],"props":{"playing":{"type":{"name":"bool"},"required":false,"description":"Set to true or false to pause or play the media.","defaultValue":{"value":"false","computed":false}},"loop":{"type":{"name":"bool"},"required":false,"description":"Set to true or false to loop the media.","defaultValue":{"value":"false","computed":false}},"controls":{"type":{"name":"bool"},"required":false,"description":"Set to true or false to display native player controls. Vimeo, Twitch and Wistia player will always display controls.","defaultValue":{"value":"true","computed":false}},"muted":{"type":{"name":"bool"},"required":false,"description":"Mutes the player.","defaultValue":{"value":"false","computed":false}},"volume":{"type":{"name":"number"},"required":false,"description":"Set the volume of the player, between 0 and 1.","defaultValue":{"value":"1","computed":false}},"source":{"type":{"name":"string"},"required":false,"description":"The url of a video or song to play.","defaultValue":{"value":"''","computed":false}},"className":{"type":{"name":"string"},"required":false,"description":"Class to apply to button.","defaultValue":{"value":"''","computed":false}},"onReady":{"type":{"name":"func"},"required":false,"description":"Called when media is loaded and ready to play. If playing is set to true, media will play immediately","defaultValue":{"value":"() => {}","computed":false}},"onStart":{"type":{"name":"func"},"required":false,"description":"Called when media starts playing","defaultValue":{"value":"() => {}","computed":false}},"onPlay":{"type":{"name":"func"},"required":false,"description":"Called when media starts or resumes playing after pausing or buffering","defaultValue":{"value":"() => {}","computed":false}},"onProgress":{"type":{"name":"func"},"required":false,"description":"Callback containing played and loaded progress as a fraction ('{ played: 0.12, playedSeconds: 11.3, loaded: 0.34, loadedSeconds: 16.7 }')","defaultValue":{"value":"() => {}","computed":false}},"onDuration":{"type":{"name":"func"},"required":false,"description":"Callback containing duration of the media, in seconds","defaultValue":{"value":"() => {}","computed":false}},"onPause":{"type":{"name":"func"},"required":false,"description":"Called when media is paused","defaultValue":{"value":"() => {}","computed":false}},"onBuffer":{"type":{"name":"func"},"required":false,"description":"Called when media starts buffering","defaultValue":{"value":"() => {}","computed":false}},"onSeek":{"type":{"name":"func"},"required":false,"description":"Called when media seeks with seconds parameter","defaultValue":{"value":"() => {}","computed":false}},"onEnded":{"type":{"name":"func"},"required":false,"description":"Called when media finishes playing","defaultValue":{"value":"() => {}","computed":false}},"onError":{"type":{"name":"func"},"required":false,"description":"Called when an error occurs whilst attempting to play media","defaultValue":{"value":"() => {}","computed":false}}},"filename":"/components/Video/Video.jsx"}

/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _main = __webpack_require__(5);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _DetailsComponent = __webpack_require__(6);
	
	var _DetailsComponent2 = _interopRequireDefault(_DetailsComponent);
	
	var _video = __webpack_require__(535);
	
	var _video2 = _interopRequireDefault(_video);
	
	var _map = __webpack_require__(1104);
	
	var _map2 = _interopRequireDefault(_map);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ComponentView = function (_React$Component) {
	  _inherits(ComponentView, _React$Component);
	
	  function ComponentView() {
	    _classCallCheck(this, ComponentView);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ComponentView.prototype.render = function render() {
	    return _react2.default.createElement(
	      _main2.default,
	      { pagePushedFunction: this.handlepushedPageLayout },
	      _video2.default && _react2.default.createElement(_DetailsComponent2.default, {
	        name: _video2.default.name,
	        linkGithub: 'https://github.com/front10/landing-page-book/tree/master/src/components/Video',
	        description: _video2.default.summary,
	        stories: _video2.default.stories,
	        importCode: _video2.default.import,
	        withStyles: _video2.default.withStyles,
	        extractProps: _video2.default.extractProps,
	        propsDescription: _map2.default.props
	      })
	    );
	  };
	
	  return ComponentView;
	}(_react2.default.Component);
	
	exports.default = ComponentView;
	module.exports = exports['default'];

/***/ }),

/***/ 535:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  name: 'Video',
	  summary: 'Now you can show video of vimeo, youtube and many other platforms very easily on your website.',
	  import: '',
	  withStyles: true,
	  stories: [{
	    name: 'Video',
	    summary: '',
	    code: '<Video source="https://youtu.be/dCrLwWdju68" />',
	    tabsActive: ['code']
	  }]
	};
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-components-video-js-4b33e2b12d9209b2189d.js